var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-input",
    _vm._b(
      {
        attrs: {
          value: _setup.currentText,
          type: _vm.type,
          placeholder: _vm.placeholder,
          maxlength: _vm.maxlength,
          "show-word-limit": _vm.showWordLimit,
        },
        on: { input: _setup.handleTextInput },
      },
      "el-input",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "template",
        { slot: "prepend" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100px" },
              attrs: { size: "mini", disabled: _vm.disabled },
              model: {
                value: _setup.currentLang,
                callback: function ($$v) {
                  _setup.currentLang = $$v
                },
                expression: "currentLang",
              },
            },
            _vm._l(_setup.descLangOptions, function (opt) {
              return _c("el-option", {
                key: opt.value,
                attrs: { label: opt.label, value: opt.value },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }